module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921032334_T.bf4f6383.jpg";